import index from '@/components/conf/index/index.vue'
import empty from '@/components/common/empty/empty.vue'
export default {
    path: '/system-settings',
    component: index,
    redirect: '/system-settings/module',
    name: '系统设置',
    iconCls: '&#xe613;',
    children: [{
        path: 'module',
        component: resolve => require(['@/components/conf/system-settings/module-manage/index.vue'], resolve),
        name: '模块管理',
        iconCls: '&#xe7f7;'
    },{
        path: 'channel',
        component: resolve => require(['@/components/conf/system-settings/channel-manage/index.vue'], resolve),
        name: '渠道模块管理',
        iconCls: '&#xe80d;'
    },{
        path: 'parameter',
        component: resolve => require(['@/components/conf/system-settings/parameter-manage/index.vue'], resolve),
        name: '参数设置',
        iconCls: '&#xe787;'
    },{
        path: 'component',
        component: resolve => require(['@/components/conf/system-settings/component-manage/index.vue'], resolve),
        name: '组件模块管理',
        iconCls: '&#xe634;',
        hiddenChildren: true,
        component: empty,
        redirect: '/system-settings/component/list',
        children: [
            {
                path: 'list',
                component: resolve => require(['@/components/conf/system-settings/component-manage/index.vue'], resolve),
                name: '模板配置列表'
            },
            {
                path: '@tpl-configure',
                component: resolve => require(['@/components/conf/system-settings/component-manage/source/configure.vue'], resolve),
                name: '模板配置'
            }
        ]
    }]
}



// WEBPACK FOOTER //
// ./src/router/system-settings.js